<main class="ma__form-page" id="main-content" tabindex="-1">

  <div class="container page-container" [formGroup]="result">

    <h3>Waste Site & Reportable Releases Results</h3>

    <div class="generic-button-group">
      <ng-container *ngIf="!isViewMap">
        <div class="generic-button-group-left">
          <button class="btn btn-default btn-custom" (click)="viewMap()">VIEW MAP</button> &nbsp;&nbsp;  <span><b>Displaying {{mapPlottingCount}} Mapped Points out of {{totalListedCount}} listed RTN’s</b></span>
        </div>
      </ng-container>
      <ng-container *ngIf="!isHideMap">
        <div class="generic-button-group-left">
          <button class="btn btn-default btn-custom" (click)="hideMap()">HIDE MAP</button> &nbsp;&nbsp; <span><b>Displaying {{mapPlottingCount}} Mapped Points out of {{totalListedCount}} listed RTN’s</b></span>
        </div>
      </ng-container>
    </div>
    <div class="col-md-12 form-row">
      <div class="col-md-1"></div>
      <div class="col-md-10">
        <ng-container *ngIf="isMapVisible">
          <div style="text-align:center">
            <span>Locations</span>
          </div>
          <app-esri-map [center]="mapCenter" [basemap]="basemapType" [zoom]="mapZoomLevel" [plotingData]="plotingMapData" (mapLoaded)="mapLoadedEvent($event)">
          </app-esri-map>
          <img class="center" src="./assets/img/map_legend2.png">
        </ng-container>
      </div>
      <div class="col-md-1"></div>

    </div>

    <br />
    <div class="search-criteria-summary-elements">
      <span>Search Criteria </span>
      <span class="search-criteria-summary-element">{{ searchCriteria }}</span>
    </div>

    <div *ngIf="resultFormGroup.length == 0; else dashboard">
      <div *ngIf="resultFormGroup.length == 0; else dashboard">
        <strong>There are no items matching the search criteria.</strong>
      </div>
    </div>

    <ng-template #dashboard>
      <div style="overflow:auto;height:500px;width:100%">
        <table class="table  table-bordered table-striped">

          <thead>
            <tr>
              <th [style.width]='column.width' *ngFor="let column of sortableColumns">
                <span style="cursor: pointer;" (click)="column.name !=null ?  sort(column):return;">{{column.title}} </span>
                <span *ngIf="column.direction != null">
                  <span *ngIf="column.direction=='asc'; then sortAscending else sortDescending"></span>
                </span>
              </th>
              <ng-template #sortDescending>
                <svg focusable="false" data-prefix="fas" data-icon="sort" class="svg-inline--fa fa-sort-down fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"></path></svg>
              </ng-template>

              <ng-template #sortAscending>
                <svg focusable="false" data-prefix="fas" data-icon="sort" class="svg-inline--fa fa-sort-up fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"></path></svg>
              </ng-template>
            </tr>
          </thead>
          <tbody>

            <tr *ngFor="let item of resultFormGroup;">

              <td style="align-items: center; vertical-align: middle;">
                <input type="checkbox" (change)="onChangeHandler(item.rtn,item.siteName,item.address,item.townName,item.complianceStatus,item.latitude,item.longitude,item.openClosed,item.closedWithUseLimitation);" />
              </td>
              <td>
                <a [routerLink]="['/detailviewer', item.rtn,item.category,item.siteName,item.aulInfo,item.complianceStatus,item.address,item.date,item.townName,item.zipCode,item.raoClass,item.notificationDate,item.locationType,item.initailStatusDate,item.source,item.pipReceived,item.regulateObjectId,item.latitude,item.longitude,item.siteType,item.phase]">
                  {{item.rtn}}
                </a>
              </td>
              <td>
                {{item.townName}}

              </td>
              <td>
                {{item.address}}

              </td>
              <td>
                {{item.zipCode}}

              </td>
              <td>
                {{item.siteName}}

              </td>
              <td>
                {{item.category}}

              </td>
              <td>
                {{item.notificationDate | date:'MM/dd/yyyy'}}

              </td>
              <td>
                {{item.complianceStatus}}

              </td>


              <td>
                {{item.date | date:'MM/dd/yyyy'}}

              </td>
              <td>
                {{item.phase}}

              </td>
              <td>
                {{item.raoClass}}

              </td>
              <td>
                {{item.chemicalType}}

              </td>
              <td>
                <a [routerLink]="['/detailviewer', item.rtn]">
                  FILES
                </a>

              </td>

            </tr>
          </tbody>
        </table>
      </div>
      <div class="row pagination" style="margin:20px 0;">
        <pagination [totalItems]="itemsCount" [itemsPerPage]="pageSize" [maxSize]="10" (pageChanged)="pageChanged($event)"></pagination>


        <div class="col-md-2 ma__select-box js-dropdown ma__select-box--optional">

          <label class="col-md-6 ma__select-box__label sr-only" aria-hidden="true" for="resultRows" style="float:left; margin-top:0;">Show Number of Rows Per Page</label>

          <div class="ma__select-box__field">
            <select class="ma__select-box__select js-dropdown-select pagination" id="resultRows" (change)="pageCountChanged($event)" style="text-align:left;font-size:14px; color:#141414">
              <!-- <option value="10">
                  10/Page
              </option> -->
              <option value="25">
                25/Page
              </option>
              <option value="50">
                50/page
              </option>
              <option value="75">
                75/page
              </option>
              <option selected="selected" value="200">
                200/page
              </option>
            </select>

            <div class="ma__select-box__link pagination">
              <span class="js-dropdown-link" style="font-size:15px; font-weight:600; color:#141414">{{pageSize}}/Page</span> <span class="ma__select-box__icon"></span>
            </div>
          </div>
        </div>
        <div class="col-md mr-auto " style="text-align:right">{{gridPageStart}} - {{gridPageEnd}} of {{itemsCount}} items </div>
      </div>

    </ng-template>
    <div class="generic-button-group">
      <div>
        <div class="generic-button-group-left">
          <button class="btn btn-default btn-custom" (click)="back()"><i class="fa fa-chevron-left"></i>&nbsp;Previous</button>
          <button class="btn btn-primary btn-custom float-right" (click)="exportExcel()">EXPORT TO EXCEL<i class="fa fa-chevron-right"></i>&nbsp;</button>
        </div>
        
      </div>
<br>
      <div class="float-right">
        <span>Please contact <a href="mailto:BWSC.eDEP@mass.gov">BWSC.eDEP@mass.gov</a> with questions.   </span><br>
        <span class="float-right">Data is updated once a day</span>
      </div>
    </div>

   


    <ngx-spinner bdColor="rgba(51, 51, 51, 1.0)" size="default" type="ball-spin-clockwise">
      <p style="color: white">Please Wait. </p>
    </ngx-spinner>

    <app-scroll-to-top></app-scroll-to-top>
  </div>
</main>
